<template>
  <!-- Modal -->
  <div class="modal fade" id="NewOrdersFileModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="custom-file">
            <input @change="processFile($event)" type="file" class="custom-file-input" id="customFile" accept="application/pdf">
            <label class="custom-file-label" for="customFile">{{translations('common.select_files')}}</label>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeFileModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="addPoFile()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NewOrdersFileModal',
  props: {},
  components: {
  },
  data () {
    return {
      tempPoFile: null,
      fileLabel: 'ファイルを選択'
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  created () {
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    processFile (event) {
      if (event.target.files[0] === undefined) {
        this.tempPoFile = null
        this.fileLabel = this.translations('common.select_files')
        return
      }
      let file = event.target.files[0]
      this.fileLabel = file.name
      let reader = new FileReader()
      let $this = this
      reader.onloadend = function () {
        $this.tempPoFile = reader.result
        document.getElementById('customFile').value = null
      }
      reader.readAsDataURL(file)
    },

    addPoFile () {
      if (this.tempPoFile === null) {
        this.$toastr.warning(this.translations('order.message_choose_file'))
        return
      }

      this.$parent.poFile = this.tempPoFile
      this.tempPoFile = null // REFRESH
      this.fileLabel = this.translations('common.select_files')
      this.$refs.closeFileModal.click()
      this.$parent.updateOrders()
    }
  }
}
</script>
